import { useMemo } from "react";
import { FixedSizeList } from "react-window";
import { WordRow } from "./WordRow";
import type { EditorWord, WordsListItemData } from "./types";

export interface WordsListProps {
  words: EditorWord[];
  onClickItem: (word: EditorWord) => void;
  onClickDelete: (word: EditorWord) => void;
  onClickRestore: (word: EditorWord) => void;
}

export function WordsList({
  words,
  onClickItem,
  onClickDelete,
  onClickRestore,
}: WordsListProps) {
  // Новый объект itemData на каждый рендер обнулял бы смысл memo(WordRow,
  // areEqual) — areEqual сравнивает data по ссылке.
  const itemData = useMemo<WordsListItemData>(
    () => ({
      words,
      onClickItem,
      onClickDelete,
      onClickRestore,
    }),
    [words, onClickItem, onClickDelete, onClickRestore]
  );

  return (
    <FixedSizeList
      height={560}
      itemCount={words.length}
      itemData={itemData}
      itemSize={56}
      width="100%"
    >
      {WordRow}
    </FixedSizeList>
  );
}
